import React from 'react';
import Radium from 'radium';
import {Container} from 'flux/utils';

import HeaderContainer from 'containers/HeaderContainer';

import HttpService from 'service/HttpService';
import OrderStore from 'stores/OrderStore';
import ProductStore from 'stores/ProductStore';

import AppConstants from 'AppConstants';
import AppUtil from 'AppUtil';
import {A, Button} from 'views/AppElements';
import {Helmet} from "react-helmet";
import Footer from 'views/Footer';

import Countdown from 'react-countdown-now';
import {Separator} from 'views/AppElements';
import { Sticky } from 'react-sticky';

import DateComponent from 'views/DateComponent';

import copy from 'copy-to-clipboard';
import Slider from "react-slick";
import ProductList from 'views/product/ProductList';

import Modal from 'react-responsive-modal';
import { OrderAction } from '../../AppAction';
import ProductAPI from 'service/api/ProductAPI';


const VIDEO_IDS = ["b2TioTkgr_w", "wstX8kMNcko", "Oc6Ku8_bpi8"];


const DASHAIN_CAMPAIGN_BANNER = [{img: "/images/banners/dashain/banner1.jpg", url: "/dashain/buyonedonateone", title: "This Dashain Buy One Donate 1 - Dashain Campaign by SetoCanvas"},
                                {img: "/images/banners/dashain/banner2.jpg", url: "/dashain/buyonedonateone", title: "This Dashain Buy One Donate 1 - Dashain Campaign by SetoCanvas"},
                                {img: "/images/banners/dashain/banner3.jpg", url: "/dashain/buyonedonateone", title: "This Dashain Buy One Donate 1 - Dashain Campaign by SetoCanvas"}];


const CAMPAIGN_URL = AppConstants.WEBSITE + "/dashain/buyonedonateone";

export const DCUtil = {
    isCampaignActive: function() {
        const today = new Date();
        const endDate = this.campaignEndDate();
        return today.getTime() < endDate.getTime();
    },

    campaignStartDate: function() {
        //Aug 29
        return new Date(2019, 7, 29);
    },
    campaignEndDate: function() {
        //Sep 30
        return new Date(2019, 8, 30);
    },

    getDashainCampaignBanner: function() {
        return DASHAIN_CAMPAIGN_BANNER;
    }
};

const ContributersList = (props) => {
    const contributers = props.contributers;
    
    if(!contributers)
        return null;

    //Ram hari Bought one Gorkhali Hustle Tshirt
    const contributersLi = contributers.map(c => {
        const productURL = AppUtil.getProductURL(c.product);
        const delivered = c.orderState === AppConstants.ORDER_STATE.DELIVERED.value;

        let donationInfo = null;
        if(delivered) {
            donationInfo = <span className="donatedInfo deliveredInfo"><i className="fa fa-check-circle" aria-hidden="true"></i> {c.quantity} T-Shirt donated to campaign.</span>;
        } else {
            donationInfo = <span className="donatedInfo pendingDeliveryInfo"><i className="fa fa-exclamation-circle" aria-hidden="true"></i> Pending Delivery.</span>;
        }
        
        const productStr = <A href={productURL}>{c.product.title}</A>;
        return <li key={c.orderId} className="eachContributer">
                    <b>{c.user.username}</b> bought {c.quantity} {productStr} {AppConstants.PRODUCT_TYPES[c.product.productType].label} <small>on <DateComponent date={c.createdDate} relative={false} /></small>
                    <br />
                    {donationInfo}
                </li>
    });
    return <ul id="contributersList">
            {contributersLi}
    </ul>
};


const CountDownRenderer = (props) => {
    const isPlural = (num) => num > 1;

    const daysLabel = <div className='flexColumn eachTimerBox'><span className='timer'>{props.formatted.days}</span> <span className='timerLabel'>day{isPlural(props.days)? 's': ''}</span></div>
    const hoursLabel = <div className='flexColumn eachTimerBox'><span className='timer'>{props.formatted.hours}</span> <span className='timerLabel'>hour{isPlural(props.hours)? 's': ''}</span></div>
    const minutesLabel = <div className='flexColumn eachTimerBox'><span className='timer'>{props.formatted.minutes}</span> <span className='timerLabel'>minute{isPlural(props.minutes)? 's': ''}</span></div>
    const secondsLabel = <div className='flexColumn eachTimerBox'><span className='timer'>{props.formatted.seconds}</span> <span className='timerLabel'>second{isPlural(props.seconds)? 's': ''}</span></div>

    return <div className='flexColumn'>
            <div className='flexRow timerBox'>
                {daysLabel}
                {hoursLabel}
                {minutesLabel}
                {secondsLabel}
            </div>
            <div id="forDashainLabel">for Dashain</div>
        </div>;
};

const DEFAULT_VIDEO_SLIDER_SETTINGS = {
    speed: 350,
    infinite: true,
    className: 'videoSlider',
    cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: true
  };

const VideosList = Radium((props) => {
    const videos = VIDEO_IDS.map(videoId => {
        const videoURL = "https://www.youtube.com/embed/"+videoId+"?autoplay=0&origin="+AppConstants.WEBSITE+"&modestbranding=1&disablekb=1&iv_load_policy=3";

        return <iframe key={videoId} className="dcYTplayer" type="text/html" 
                            src={videoURL} 
                            frameBorder="0" allowFullScreen></iframe>;
    });

    return <div style={{width: "60%", "@media (max-width: 884px)": {width: '100%', margin:'0 auto'}}} 
                    id="dashainCampaginVideoContainer">
            
                <Slider {...DEFAULT_VIDEO_SLIDER_SETTINGS}>
                    {videos}        
                </Slider>
            
            
    </div>
});



const FeaturedProductsModal = (props) => {

    const products = props.products;

    return <Modal closeOnOverlayClick={false} open={props.open} 
            onClose={props.onClose} 
            classNames={{ modal: 'dashain-campaign-modal', closeIcon: 'dashain-campaign-close-icon' }}>
                <div>
                    <ProductList products={products} showSlider={true} 
                                    title={"FEATURED PRODUCTS"} 
                                    productViewMode="productOnly" navigator="arrows" 
                                    infinite={true}
                                    autoplay={false} id="featuredProducts"/>

                    <Button id="browseMoreBtn" href="/" mui='true' color='primary'>Browse More</Button>
                </div>
        </Modal>
};

const CampaignStat = Radium((props) => {
    const campaignStat = props.campaignStat;

    return <div style={props.style} id="campaignStat">
                {
                    DCUtil.isCampaignActive() && 
                    <div>
                        <h1 id="tshirtRemaining"><b>{campaignStat.totalRemaining}</b> Tshirts Remaining</h1>
                        <h4 id="tshirtFulfilled"><b>{campaignStat.totalFulfilled}/<small>100</small> Tshirts Fulfilled</b></h4>
                    </div>
                }
                
                {
                    !DCUtil.isCampaignActive() && 
                    <div>
                        <h1 id="tshirtFulfilled"><b>{campaignStat.totalFulfilled}/<small>100</small> Tshirts Fulfilled</b></h1>
                    </div>
                }
                
                <Separator style={{margin: '0px auto 25px auto', width: '100%'}} />
                
                <Countdown date={DCUtil.campaignEndDate()} renderer={CountDownRenderer} />
                <Button onClick={props.onContributeNowClick} mui='true' color='primary' style={{width: '100%'}}>Contribute Now</Button>

                <h3 style={{textAlign: 'center'}}><b>Help by Sharing</b></h3>
                <Separator style={{margin: '0px auto 25px auto', width: '100%'}} />
                
                <h4 style={{fontSize: '90%', color: 'gray'}}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i> Use the link below to share on Facebook, Twitter, Blog and other platforms.
                </h4>
                <div className="flexRow">
                        <input id="campaignLinkInput" type="text" value={CAMPAIGN_URL} readOnly={true} style={{flexGrow: '1', padding: '5px 10px'}}/>
                        <Button id="copyLinkBtn" onClick={props.onCopy}><i className="fa fa-files-o" aria-hidden="true" /> Copy</Button>
                </div>
                {
                    props.copied &&
                    <small>Copied. You can paste it now.</small>
                }
                
                <div id="socialShareBtns" className="flexRow">
                    <A className="fbLink" href="https://www.facebook.com/" mui='true'><i className="fa fa-facebook" aria-hidden="true"></i> Facebook</A>
                    <A className="fbLink" href="https://twitter.com/home" mui='true'><i className="fa fa-twitter" aria-hidden="true"></i> Twitter</A>
                    
                </div>
            </div>
});

class BuyOneDonateOne extends React.Component {
    static getStores() {
		return [OrderStore, ProductStore];
    }

    static calculateState(prevState) {
		let newState = {
                orders: OrderStore.getActionOrders(OrderAction.LOAD_DASHAIN_CAMPAIGN_ORDERS),
                featuredProducts: ProductStore.getDashainFeaturedProducts(),
                openFeaturedProducts: prevState? prevState.openFeaturedProducts: false
			};
		return newState;
	}
    
    constructor(props){
		super(props);
		this.state = {copied: false, openFeaturedProducts: false};
        this.onCopy = this.onCopy.bind(this);
        this.onContributeNowClick = this.onContributeNowClick.bind(this);
        this.onFeaturedProductsModalClose = this.onFeaturedProductsModalClose.bind(this);

        this.getCampaignStat = this.getCampaignStat.bind(this);
    }

    componentDidMount() {	
        if(!this.state.orders) {
            HttpService.getDashainCampaignOrders();
        }
    }

    onCopy() {
        this.setState({copied: copy(CAMPAIGN_URL)});
    }

    onContributeNowClick() {
        this.setState({openFeaturedProducts: true});

        if(!this.state.featuredProducts) {
            ProductAPI.getFeaturedProductsForDashain();
        }
    }

    onFeaturedProductsModalClose() {
        this.setState({openFeaturedProducts: false});
    }
    
    getCampaignStat() {
        if(this.state.orders) {
            const totalFulfilled = 25 + this.state.orders.size;
            return {totalFulfilled: totalFulfilled, 
                    totalRemaining: 100 - totalFulfilled};
        }    

        return {totalFulfilled: "-", totalRemaining: "-"};
    }

    render() {
        const campaignStat = this.getCampaignStat();

        return <div id="dashainCampaignPage">
					<Helmet>
						<title>This Dashain Buy One, Donate 1 | Seto Canvas</title>
    					<meta name="description" content="This Dashain, Seto Canvas Team will be donating Dashain T-Shirts to the needy and less fortunate people who hardly get to wear any new cloth in years." />
					</Helmet>

					<HeaderContainer />
                    
                    
                    <br />
                    <div className="mainContainer">
                        <div id="campaignHeader" className="flexRow" style={{height: '380px', marginBottom: '20px', "@media (max-width: 884px)": {height: 'auto'}}}>
                            <VideosList />
                            

                            <div style={{'@media (min-width: 884px)': {display: 'none'}}} id="mobileStat">

                                <CampaignStat style={{height: 'auto', margin: '30px 0 0 0'}} campaignStat={campaignStat} 
                                                        onContributeNowClick={this.onContributeNowClick} 
                                                        copied={this.state.copied} onCopy={this.onCopy} />
                            </div>
                            <div style={{'@media (max-width: 884px)': {display: 'none'}}} id="webStat">
                                <Sticky topOffset={128}>
                                    {({style, isSticky}) => {
                                        style.margin = '0 10px';
                                        style.width = 'inherit';
                                        style.top = '60px';

                                        return <CampaignStat style={style} campaignStat={campaignStat} 
                                                        onContributeNowClick={this.onContributeNowClick} 
                                                        copied={this.state.copied} onCopy={this.onCopy} />
                                    }} 
                                </Sticky>
                            </div>
                            

                        </div>


                        <div id="campaignBody" className="flexColumn">
                            
                            <div style={{width: "60%", "@media (max-width: 884px)": {width: '100%'}}}>
                                <p id="campaignInfo">
                                    <span id="highlightedMsg">This Dashain, we plan on donating at least <b>100 T-Shirts</b> and we need <b>YOUR HELP to reach that target</b>.</span>
                                    
                                    <span>Simply purchase any T-Shirts from our website and for every T-Shirts purchased during the period before Ghatasthapana,
                                    SetoCanvas Team will donate one T-Shirt to the campaign.</span>
                                    <br />
                                    SetoCanvas Team will also initially donate <b>25 T-Shirts</b> to the campaign. So help us donate the remaining <b>75 T-Shirts</b>.
                                </p>
                                
                                <br />
                                <h1><b>Contributers List <i className="fa fa-thumbs-o-up" aria-hidden="true"></i></b></h1>

                                <Separator style={{margin: '0px auto 25px auto', width: '100%'}} />
                                <h2 id="setoCanvasContribution"><b>- 25 T-Shirts from SetoCanvas Team</b></h2>
                                <ContributersList contributers={this.state.orders} />

                                <div id="contributeNowSecondBtn">
                                    <Button onClick={this.onContributeNowClick} mui='true' color='primary'>Contribute Now</Button>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                    

                    <FeaturedProductsModal open={this.state.openFeaturedProducts} products={this.state.featuredProducts} onClose={this.onFeaturedProductsModalClose} />
                    <Footer />
        </div>
    }
}

export default Radium(Container.create(BuyOneDonateOne));


// WEBPACK FOOTER //
// ./src/pages/campaigns/BuyOneDonateOne.js